import { Flex } from "@similarweb/ui-components/foundations";
import styled from "styled-components";

const FiltersContainers = styled(Flex)`
    margin: 16px 16px 16px 0;
`;

export const FiltersContainersWrapper = styled(FiltersContainers)`
    min-height: 32px;
`;

export const ChipdownItem = styled.div`
    margin-right: 8px;
`;
